import { useEffect, useState } from 'react';
import styles from './thinking.module.scss';
import { getNextStep } from '../../App';

const ThinkingSection = ({ updatePage }) => {
    const animation = [
        'https://static.yeschef.me/thinking2-TL-1.gif',
        'https://static.yeschef.me/thinking2-TR-2.gif',
        'https://static.yeschef.me/thinking2-BL-3.gif',
        'https://static.yeschef.me/thinking2-BR-4.gif'
    ];

    const thinkingMessages = [
        "Digesting Responses",
        "Prepping Profile",
        "Sharpening Knives",
        "Preheating Oven",
        "Analyzing Tastes",
        "Personalizing Results",
        "Plating Recommendations"
    ];

    const [imageIndex, setImageIndex] = useState(0);
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        fetch('https://yc-api.yeschef.me/personalize/typeform', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_uuid: localStorage.getItem('typeform_uuid') })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('AI personalization result:', data);
        })
        .catch(err => {
            console.error('Error calling personalize API:', err);
        });
    }, []);

    // Cycle animations and messages every 2.5 seconds
    useEffect(() => {
        const imageInterval = setInterval(() => {
            setImageIndex(prev => (prev + 1) % animation.length);
        }, 2500);

        const messageInterval = setInterval(() => {
            setMessageIndex(prev => {
                if (prev < thinkingMessages.length - 1) {
                    return prev + 1;
                } else {
                    clearInterval(messageInterval); // Stop updating once at the last message
                    return prev;
                }
            });
        }, 1428);
    
        return () => {
            clearInterval(messageInterval);
            clearInterval(imageInterval);
        }
    }, []);

    // Transition after total time (e.g., 10 seconds)
    useEffect(() => {
        const timeout = setTimeout(() => {
            updatePage(getNextStep('thinking'));
        }, 10000);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className={styles.ThinkingSection}>
            <h2 className={styles.Title}>Analyzing Interests.</h2>
            <div className={styles.Animation}>
                <div className={styles.Image}>
                    <img src={animation[imageIndex]} className={styles.img} alt="Thinking animation" width="179" height="196" />
                </div>
                <div className={styles.AnimatedText}>
                    {thinkingMessages[messageIndex]}..
                </div>
            </div>
        </div>
    );
};

export default ThinkingSection;
